import Route from '@ember/routing/route';

/**
 * Minimal route for the share-intent drawer.
 * Unlike the /extract route, we do NOT redirect unauthenticated users to /login.
 * Reason: SendIntentActivity.onPause() calls finish(), so any navigation that backgrounds
 * the Activity destroys the WebView. Auth state is checked inline inside the component.
 */
export default class ShareRoute extends Route {}
